module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_39.dot-30062cda7635b27e7195c36b804f3807.svg";